import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import T from "../../components/T";
import { ChevronLeft, Users } from "lucide-react";

export default function CommunityCircle() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <AppShell>
      <div className="px-8 pt-16 pb-6" data-testid="page-community">
        <button onClick={() => navigate("/sanctuary")} className="flex items-center gap-1 text-sm text-foreground/55 hover:text-brand mb-2">
          <ChevronLeft className="w-4 h-4" /> {t("v11.back_to_sanctuary")}
        </button>
        <p className="font-script text-2xl text-brand">{t("v11.community.kicker")}</p>
        <h1 className="font-serif text-4xl leading-tight"><T i18nKey="v11.community.h" /></h1>
      </div>
      <div className="px-8 pb-10 space-y-4">
        <div className="rounded-3xl bg-brand/8 border border-brand/20 p-6 flex items-start gap-3">
          <Users className="w-5 h-5 text-brand mt-1 shrink-0" />
          <p className="text-foreground/85 leading-relaxed">{t("v11.community.p1")}</p>
        </div>
        <div className="rounded-3xl bg-card border border-border p-6">
          <p className="text-foreground/80 leading-relaxed">{t("v11.community.p2")}</p>
        </div>
        <div className="rounded-3xl bg-card border border-border p-6">
          <p className="font-serif italic text-foreground/85 leading-relaxed">{t("v11.community.p3")}</p>
        </div>
      </div>
    </AppShell>
  );
}
